module.exports = __webpack_public_path__ + "media/images/items/demo_image-b2762b4cd2f5ae36b83e5e7e7deaa168.jpg";